<template>
  <div class="messageNotification">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="messageCon">
      <div class="messageTabBox">
        <div class="proCon">
          <div class="tabTitle clearfix">
            <div class="mobileNavCon">
              <ul id="messageTab" class="nav nav-tabs">
                <li class="active">
                  <a href="#toDoList" data-toggle="tab" @click="selectMessage(1)">待办事项({{toDoTotal}})<div class="tabLine"></div></a>
                </li>
                <li>
                  <a href="#notification" data-toggle="tab" @click="selectMessage(2)">消息通知({{noticeTotal}})<div class="tabLine"></div></a>
                </li>
                <li>
                  <a href="#completedItems" data-toggle="tab" @click="selectMessage(3)">已办事项({{alreadyDoTotal}})<div class="tabLine"></div></a>
                </li>
              </ul>
            </div>
            <div class="mobileClass hidden-md hidden-lg">
              <a data-toggle="modal" data-target="#messageModal" @click="showModal"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/filter_icon.png" alt=""></a>
              <div class="modal fade" id="messageModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <div class="classCon clearfix">
                      <ul id="messageClassTab" class="nav nav-tabs nav-stacked col-xs-3 col-sm-3">
                        <li class="active">
                          <a href="#messageClassList" data-toggle="tab">消息来源</a>
                        </li>
                      </ul>
                      <div class="tabCon col-xs-9 col-sm-9">
                        <div id="messageClassTabCon" class="tab-content">
                          <div class="tab-pane fade in active" id="messageClassList">
                            <el-radio-group v-model="messageRadio">
                              <el-radio label="">全部</el-radio>
                              <el-radio label="RECRUITING_PLATFORM">采招系统</el-radio>
                              <el-radio label="JICHAI_MALL">集采商城</el-radio>
                              <el-radio label="Order_Coordination">订单协同</el-radio>
                              <el-radio label="Basic_Application">基础应用</el-radio>
                              <el-radio label="SRM">供应商管理</el-radio>
                            </el-radio-group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="classBtn clearfix">
                      <el-button class="col-xs-6 col-sm-6" @click="cancelClass">取消</el-button>
                      <el-button class="col-xs-6 col-sm-6" @click="confirmClass">确认</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="input-group pull-right hidden-lg hidden-md hidden-xs hidden-sm">
              <input type="text" class="form-control" placeholder="请输入关键词" ref="selectKey" v-model="selectKey" @keyup.enter="selectKeyWord()">
              <span class="input-group-btn">
                <button tabindex="0" class="btn" type="submit" aria-label="Search" @click="selectKeyWord()">
                  <img class="search-icon" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/search_icon.png" width="20px" alt="Search">
                </button>
              </span>
            </div><!-- /input-group -->
          </div>
          <div class="clearfix">
            <div class="input-group pull-right">
              <input type="text" class="form-control" placeholder="请输入关键词" ref="selectKey" v-model="selectKey" @keyup.enter="selectKeyWord()">
              <span class="input-group-btn">
                <button tabindex="0" class="btn" type="submit" aria-label="Search" @click="selectKeyWord()">
                  <img class="search-icon" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/search_icon.png" width="20px" alt="Search">
                </button>
              </span>
            </div>
          </div><!-- /input-group -->
          <div class="tabCon">
            <div id="messageTabContent" class="tab-content">
              <div class="clearfix tabConBox tab-pane fade in active" id="toDoList">
                <v-messageTable :messageData="toDoMessageData" :messageType="selectMessageType" :sourceText="sourceText" @changeProductline="changeProductline"></v-messageTable>
                <v-pagination class="hidden-xs hidden-sm" :total='toDoTotal' :display='10' :current-page='currentPageToDo' @pagechange="pagechange"></v-pagination>
              </div>
              <div class="clearfix tabConBox tab-pane fade" id="notification">
                <el-button class="allReadBtn" @click="allRead">全部标为已读</el-button>
                <v-messageTable :messageData="noticeMessageData" :messageType="selectMessageType" :sourceText="sourceText" @changeProductline="changeProductline"></v-messageTable>
                <v-pagination class="hidden-xs hidden-sm" :total='noticeDateTotal' :display='10' :current-page='currentPageNotice' @pagechange="pagechange"></v-pagination>
              </div>
              <div class="clearfix tabConBox tab-pane fade" id="completedItems">
                <v-messageTable :messageData="alreadyMessageData" :messageType="selectMessageType" :sourceText="sourceText" @changeProductline="changeProductline"></v-messageTable>
                <v-pagination class="hidden-xs hidden-sm" :total='alreadyDoTotal' :display='10' :current-page='currentPageAlreadyDo' @pagechange="pagechange"></v-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button v-show="!lineShow" type="button" class="btn btn-default btn-lg hidden-md hidden-lg" @click="morePagechange()">MORE</button>
      <p class="lineCon" v-show="lineShow">
        <span class="line"></span>
        <el-button type="text" class="hidden-md hidden-lg" disabled>我也是有底线的</el-button>
        <span class="line"></span>
      </p>
    </div>
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import messageTable from '@/components/messageTable'
  import bootPage from '@/components/bootPage'
  import footer from '@/components/v-footer'
  import pagination from '@/components/pagination'
  import backToTop from '@/components/backToTop'
  import { mapState } from 'vuex'

  export default {
    props: [],
    data () {
      return {
        userInfo:{},
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        navigationColumnInfos:[],
        footerColumnInfos:[],
        paramInfo:{},
        bannerInfo: {title: '消息通知',content: "Message notification"},
        webConfigInfo: {},
        messageData: [{
          date: '2018-11-19  12:21',
          title: '广州市番禺区实验中学广州市番禺区实',
          source: '采招系统'
        }, {
          date: '2018-11-20  11:34',
          title: '永康市不动产登记结果自助查询机',
          source: '协同系统'
        }, {
          date: '2018-11-21  12:45',
          title: '笔记本电脑',
          source: '协同系统'
        }, {
          date: '2018-11-22  11:26',
          title: '新川学校周边道路及管线工程施工/标',
          source: '采招系统'
        }, {
          date: '2018-11-19  12:21',
          title: '第四届中国绿化博览会博览园建设项目',
          source: '系统消息'
        }],
        toDoTotal:0,
        noticeTotal:0,
        noticeDateTotal:0,
        alreadyDoTotal:0,
        currentPageToDo:1,
        currentPageNotice:1,
        currentPageAlreadyDo:1,
        currentPageToDoMore:2,
        currentPageNoticeMore:2,
        currentPageAlreadyDoMore:2,
        toDoMessageData:[],
        toDoMessageExtData:[],
        noticeMessageData:[],
        noticeMessageExtData:[],
        alreadyMessageData:[],
        alreadyMessageExtData:[],
        selectMessageType:1,
        toDoProductLine:'',
        noticeProductLine:'',
        alreadyProductLine:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        productLine:'',
        selectKey:'',
        messageRadio:'',
        messageCache:'',
        lineShow:false,
        sourceText:'消息来源',
        noticeInfo:[],
        tabName:"#toDoList",
      }
    },
    computed: mapState([
    'KP'
    ]),
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-messageTable': messageTable,
      'v-bootPage': bootPage,
      'v-footer': footer,
      'v-pagination': pagination,
      'v-backToTop': backToTop
    },
    watch:{
      productLine(val){
//        if(val != ''){
          //待办事项
        if(this.selectMessageType == 1){
          this.currentPageToDo = 1;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            productLine:val,
            isFinish: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageToDo,
            pageSize: 10
          }).then((res) => {
            this.data = res.data;
//            this.toDoMessageData = this.data.queryTodoResponse.list;
//            this.toDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          this.toDoMessageData = this.data.queryTodoResponse.list;
          this.toDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          this.noticeTotal = Number(this.data.systemMessageNumber);
          this.alreadyDoTotal = Number(this.data.alreadyDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }

        //消息通知
        if(this.selectMessageType == 2){
          this.currentPageNotice = 1;
          this.$axios.post('/onelink.mdata.main.api/message/findNoticeInfo', {
            productLine:val,
            isFinish: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageNotice,
            pageSize: 10
          }).then((res) => {
            this.data = res.data;
//            this.noticeMessageData = this.data.queryNotifyResponse.list;
//            this.noticeTotal = Number(this.data.queryNotifyResponse.pageInfo.totalRecords);
          this.noticeMessageData = this.data.queryNotifyResponse.list;
          this.noticeDateTotal = Number(this.data.queryNotifyResponse.pageInfo.totalRecords);
          this.noticeTotal = Number(this.data.systemMessageNumber);
          this.alreadyDoTotal = Number(this.data.alreadyDoNumber);
          this.toDoTotal = Number(this.data.toDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }

        //已办事项
        if(this.selectMessageType == 3){
          this.currentPageAlreadyDo = 1;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            productLine:val,
            isFinish: 1,
            keyword: this.selectKey,
            pageNo: this.currentPageAlreadyDo,
            pageSize: 10
          }).then((res) => {
            this.data = res.data;
//            this.alreadyMessageData = this.data.queryTodoResponse.list;
//            this.alreadyDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          this.alreadyMessageData = this.data.queryTodoResponse.list;
          this.alreadyDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          this.noticeTotal = Number(this.data.systemMessageNumber);
          this.toDoTotal = Number(this.data.toDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }
//        }
      }
    },
    created () {
      if(this.getToken('isLogin') == 100){

        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      }else{
        this.$router.push({path:'/login',query:{redirectURL:window.location.href}});
      }
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainMessageInfo', {
        pageNo : 1,
        pageSize : 10
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.toDoMessageData = this.data.queryTodoResponse.list;
        this.toDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
        this.noticeTotal = Number(this.data.systenMessageNumber);
      this.noticeInfo = this.data.noticeDtos;
        this.alreadyDoTotal = Number(this.data.alreadyDoNumber);
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
        if(this.$route.query.selectMessage == 2){
          this.tabName="#notification"
          $('#messageTab a[href="'+this.tabName+'"]').tab('show');
          this.selectMessage(2)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
      this.ulWidth();
      this.resizeUlWidth();
      this.modalClickFn();
    },
    updated(){
      this.ulWidth()
    },
    methods: {
      ulWidth () {
        // 动态计算ul的宽度
        let scrollwrap = $('#messageTab')
        let lis = $('li', scrollwrap)
        let sum = 0
        // 遍历每一个li元素
        lis.each(function (index, el) {
          let _el = $(el)
          // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
          // outerWidth 代表的是border+padding+width
          sum += _el.width()
        })
        // 将累加的值直接复制给ul元素
        scrollwrap.width(sum + 3)
      },
      resizeUlWidth(){
        $(window).resize(() => {
          if($('.tabTitle').width() < 750){
            this.ulWidth();
          }else{
            $('#messageTab').width('auto')
          }
        })
      },
      morePagechange(){
        //待办事项
        if(this.selectMessageType == 1){
          this.currentPageToDoMore = this.currentPageToDoMore + 1;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageToDoMore,
            pageSize: 5,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
          if(this.data.queryTodoResponse.list.length<=0){
            this.lineShow=true;
          }
            this.toDoMessageExtData = this.data.queryTodoResponse.list;
            this.toDoMessageExtData.forEach(element =>{
              this.toDoMessageData.push(element);
            });
            this.toDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          }).catch((err) => {
              console.log(err)
          })
        }

        //消息通知
        if(this.selectMessageType == 2){
          this.currentPageNoticeMore = this.currentPageNoticeMore + 1;
          this.$axios.post('/onelink.mdata.main.api/message/findNoticeInfo', {
            // isRead: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageNoticeMore,
            pageSize: 5,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
          if(this.data.queryNotifyResponse.list.length<=0){
            this.lineShow=true;
          }
            this.noticeMessageExtData = this.data.queryNotifyResponse.list;
            this.noticeMessageExtData.forEach(element =>{
              this.noticeMessageData.push(element);
            })
            this.noticeDateTotal = Number(this.data.queryNotifyResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.queryNotifyResponse.pageInfo.totalRecords);
          }).catch((err) => {
              console.log(err)
          })
        }

        //已办事项
        if(this.selectMessageType == 3){
          this.currentPageAlreadyDoMore = this.currentPageAlreadyDoMore + 1;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 1,
            keyword: this.selectKey,
            pageNo: this.currentPageAlreadyDoMore,
            pageSize: 5,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
          if(this.data.queryTodoResponse.list.length<=0){
            this.lineShow=true;
          }
            this.alreadyMessageExtData = this.data.queryTodoResponse.list;
            this.alreadyMessageExtData.forEach(element =>{
              this.alreadyMessageData.push(element);
            });
            this.alreadyDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          }).catch((err) => {
              console.log(err)
          })
        }
      },
      pagechange(currentPage){
        //待办事项
        if(this.selectMessageType == 1){
          this.currentPageToDo = currentPage;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageToDo,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.toDoMessageData = this.data.queryTodoResponse.list;
            this.toDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          }).catch((err) => {
              console.log(err)
          })
        }

        //消息通知
        if(this.selectMessageType == 2){
          this.currentPageNotice = currentPage;
          this.$axios.post('/onelink.mdata.main.api/message/findNoticeInfo', {
            // isRead: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageNotice,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.noticeMessageData = this.data.queryNotifyResponse.list;
            this.noticeDateTotal = Number(this.data.queryNotifyResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.systemMessageNumber);
          }).catch((err) => {
              console.log(err)
          })
        }

        //已办事项
        if(this.selectMessageType == 3){
          this.currentPageAlreadyDo = currentPage;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 1,
            keyword: this.selectKey,
            pageNo: this.currentPageAlreadyDo,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.alreadyMessageData = this.data.queryTodoResponse.list;
            this.alreadyDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
          }).catch((err) => {
              console.log(err)
          })
        }
      },
      selectMessage(messageType){
        this.selectMessageType = messageType;
        this.lineShow=false;
        //待办事项
        if(messageType == 1){
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageToDo,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.toDoMessageData = this.data.queryTodoResponse.list;
            this.toDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.systemMessageNumber);
            this.alreadyDoTotal = Number(this.data.alreadyDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }

        //消息通知
        if(messageType == 2){
          this.$axios.post('/onelink.mdata.main.api/message/findNoticeInfo', {
            // isRead: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageNotice,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.noticeMessageData = this.data.queryNotifyResponse.list;
            this.noticeDateTotal = Number(this.data.queryNotifyResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.systemMessageNumber);
            this.alreadyDoTotal = Number(this.data.alreadyDoNumber);
            this.toDoTotal = Number(this.data.toDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }

        //已办事项
        if(messageType == 3){
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 1,
            keyword: this.selectKey,
            pageNo: this.currentPageAlreadyDo,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.alreadyMessageData = this.data.queryTodoResponse.list;
            this.alreadyDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.systemMessageNumber);
            this.toDoTotal = Number(this.data.toDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }
      },
      selectKeyWord(){
        this.lineShow=false;
        //待办事项
        if(this.selectMessageType == 1){
          this.currentPageToDo = 1;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageToDo,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.toDoMessageData = this.data.queryTodoResponse.list;
            this.toDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.systemMessageNumber);
            this.alreadyDoTotal = Number(this.data.alreadyDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }

        //消息通知
        if(this.selectMessageType == 2){
          this.currentPageNotice = 1;
          this.$axios.post('/onelink.mdata.main.api/message/findNoticeInfo', {
            // isRead: 0,
            keyword: this.selectKey,
            pageNo: this.currentPageNotice,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.noticeMessageData = this.data.queryNotifyResponse.list;
            this.noticeDateTotal = Number(this.data.queryNotifyResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.systemMessageNumber);
            this.alreadyDoTotal = Number(this.data.alreadyDoNumber);
            this.toDoTotal = Number(this.data.toDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }

        //已办事项
        if(this.selectMessageType == 3){
          this.currentPageAlreadyDo = 1;
          this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
            isFinish: 1,
            keyword: this.selectKey,
            pageNo: this.currentPageAlreadyDo,
            pageSize: 10,
            productLine: this.productLine
          }).then((res) => {
            this.data = res.data;
            this.alreadyMessageData = this.data.queryTodoResponse.list;
            this.alreadyDoTotal = Number(this.data.queryTodoResponse.pageInfo.totalRecords);
            this.noticeTotal = Number(this.data.systemMessageNumber);
            this.toDoTotal = Number(this.data.toDoNumber);
          }).catch((err) => {
              console.log(err)
          })
        }
      },
      changeProductline(val){
        if(val == 'RECRUITING_PLATFORM'){
          this.sourceText = '<span style="color: #3F88E0">采招系统</span>';
        }else if(val == 'JICHAI_MALL'){
          this.sourceText = '<span style="color: #3F88E0">集采商城</span>';
        }else if(val == 'Order_Coordination'){
          this.sourceText = '<span style="color: #3F88E0">订单协同</span>';
        }else if(val == 'Basic_Application'){
          this.sourceText = '<span style="color: #3F88E0">基础应用</span>';
        }else if(val == 'SRM'){
          this.sourceText = '<span style="color: #3F88E0">供应商管理</span>';
        }else{
          this.sourceText = '消息来源';
        }
        this.productLine = val;
      },
      //    移动端打开分类弹框
      showModal(){
        this.messageCache=this.messageRadio;
      },
//    移动端弹框确认按钮
      confirmClass(){
        this.lineShow=false;
        this.changeProductline(this.messageRadio);
        $('#messageModal').modal('hide');
      },
//    移动端弹框取消按钮
      cancelClass(){
        $('#messageModal').modal('hide');
        this.messageRadio=this.messageCache;
      },
//    模态框关闭事件
      modalClickFn(){
        $('#messageModal').on('click', (e) => {
          if(e.target.id=='messageModal'){
            this.cancelClass();
          }
        })
      },
      //全部标为已读
      allRead(){
        this.$confirm('是否把所有未读信息标为已读，并且无法撤回。确定继续吗？', '', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning',
          lockScroll:false,
          customClass:'allReadConfirm',
          iconClass:'el-icon-warning-outline'
        }).then(() => {
          this.$axios.post('/onelink.mdata.main.api/message/markAllRead', {
          }).then((res) => {
            if(res.data.data.operateResult){
              this.$message({
                type: 'success',
                message: '已把全部未读信息标记为已读'
              });
              this.selectKeyWord();
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // });
        });
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/messageNotification/index.vue